import { getCloudinaryImageUrl } from '@utils/images'
import Image from 'next/image'

const Tablet = (props: any) => {
  // Common text styles based on Figma (Uppercase removed)
  const textBaseStyle = 'font-extrabold leading-[0.9em] text-[40px] uppercase tracking-[-0.05em] mt-[3px]'
  const textSmallStyle = 'font-normal font-swinton leading-[1em] text-[16px] tracking-[-0.05em]'

  return (
    <div className='p-4 font-abcd bg-white'>
      <div className='snap-section-start hide-floating-logos relative top-[10px]' />
      <div className='grid grid-cols-2 gap-4'>
        <div className='flex flex-col space-y-1'>
          <div className='text-left'>
            <p className={`${textBaseStyle}  `}>{props.block5Heading1}</p>
            <p className={`${textSmallStyle} `}>{props.block5Heading1Brief}</p>
          </div>
          <div className='w-full aspect-[77/90] relative'>
            {props?.block5Image2?.data?.attributes?.url && (
              <Image
                src={getCloudinaryImageUrl(props?.block5Image2.data.attributes.url, 'q_auto,dpr_auto,f_auto,w_968')}
                alt=''
                layout='fill'
                objectFit='cover'
              />
            )}
          </div>
        </div>

        <div className='flex flex-col space-y-0'>
          <div className='w-full h-full relative'>
            {props?.block5Image1?.data?.attributes?.url && (
              <Image
                src={getCloudinaryImageUrl(props?.block5Image1?.data?.attributes?.url, 'q_auto,dpr_auto,f_auto')}
                alt=''
                layout='fill'
                objectFit='cover'
              />
            )}
          </div>
          <div className='text-left !-mt-2'>
            <p className={`${textBaseStyle} `}>{props.block5Heading2}</p>
            <p className={`mt-2 ${textSmallStyle} `}>{props.block5Heading2Brief}</p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Tablet
